export const LABEL_PAYMENT_TYPE = 'Comment souhaitez-vous payer ?';
export const LABEL_PAYMENT_CARD = 'Cartes de paiement';
export const LABEL_DISABLE_METHOD_ERROR =
  'Une erreur est survenue. Veuillez essayer ultérieurement.';
export const PAYMENT_REFUSED = 'Le paiement a échoué pour votre commande numéro : ';
